import Sockjs from "sockjs-client";
import Stomp from "webstomp-client";
import TokenService from "@/services/TokenService";
import { baseURLSocket } from "@/plugins/Axios";

const socketAddress = `${baseURLSocket}/ws?access_token=${TokenService.getBearerToken()}`;

class SocketService {
  constructor(address, options, events) {
    this.address = address;
    this.options = options;
    this.client = null;
    this.events = {
      onmessage: () => {},
      onerror: () => {},
      onclose: () => {},
      ...events,
    };
  }

  promiseConnect() {
    return new Promise((resolve, reject) => {
      const client = this.connect();
      try {
        client.connect({}, () => {
          resolve(client);
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  connect() {
    const socket = new Sockjs(this.address);
    socket.onclose = this.events.onclose;
    socket.onmessage = this.events.onmessage();
    this.client = Stomp.over(socket, this.options);
    return this.client;
  }

  disconnect() {
    if (this.client) {
      this.client.disconnect();
    }
    return true;
  }
}

export default new SocketService(
  socketAddress,
  { debug: process.env.NODE_ENV === "development" || false },
  {}
);
